module.exports = __webpack_public_path__ + "static/img/term_library_delete_single.0b1701c2.gif";